import { margins, widths } from '@olist/styled-system';
import styled, { css, keyframes } from 'styled-components';
import Caption from '../Text/Caption/Caption.js';
import '../Text/DetailedSubheading/DetailedSubheading.js';
import '../Text/OverlineLg/OverlineLg.js';
import '../Text/OverlineMd/OverlineMd.js';
import '../Text/ParagraphLg/ParagraphLg.js';
import ParagraphMd from '../Text/ParagraphMd/ParagraphMd.js';
import '../Text/SectionHeading/SectionHeading.js';
import '../Text/SectionSubheading/SectionSubheading.js';
import '../Text/Title/Title.js';

const Wrapper = styled.div(({ theme: { olist: { components: { input }, }, }, }) => css `
    display: flex;
    flex-direction: column;
    padding: 2px;

    ${Caption} {
      color: ${input['helper-text'].color};
    }

    ${margins}
  `);
const WrapperInput = styled.div(({ theme: { olist: { components: { input }, }, }, feedback, showFeedbackIcon, disabled, readOnly, isLoading, }) => css `
    height: 48px;

    display: flex;
    align-items: center;

    border-radius: ${input.radius};
    box-sizing: border-box;

    margin-top: ${input.margin};

    background-color: ${input['background-color']};

    ${widths}

    ${disabled
    ? css `
          outline: 2px solid ${input.disabled['border-color']};
          background-color: ${input.disabled.background};
          cursor: not-allowed;
        `
    : feedback &&
        !showFeedbackIcon &&
        feedback != 'valid' &&
        !isLoading &&
        !readOnly
        ? css `
          outline: 2px solid ${input.feedback[feedback]['border-color']};
        `
        : css `
          outline: 1px solid ${input['border-color']};
          ${readOnly
            ? css `
                background-color: ${input.readOnly.background};
              `
            : ''}
        `}

    &:focus-within {
      outline: 2px solid ${input.focused['border-color']};
    }
  `);
const StyledInput = styled.input(({ hasPrefix, theme: { olist: { components: { input }, }, }, }) => css `
    background-color: transparent;
    box-shadow: none;
    border: none;

    width: 100%;
    height: 100%;
    padding: ${hasPrefix ? `0 ${input.padding} 0 0` : `0 ${input.padding}`};

    &:focus {
      outline: transparent;
    }

    font-family: ${input['font-family']};
    line-height: ${input['line-height']};

    font-size: ${input['font-size'].desktop};

    color: ${input.color};

    &:disabled {
      cursor: not-allowed;
    }

    &::placeholder {
      color: ${input.placeholder.color};
      font-style: italic;
    }
  `);
const rotate = keyframes `
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;
const scaleIcon = keyframes `
  from {
    transform: scale(0);
  }

  to {
    transform: scale(1);
  }
`;
const Suprefix = styled.span(({ theme: { olist: { components: { input }, }, }, sufix, hasSuffix, }) => css `
    ${sufix
    ? css `
          padding-left: ${input.suprefix.margin};
          padding-right: ${hasSuffix ? 0 : input.padding};
        `
    : css `
          padding-left: ${input.padding};
          padding-right: ${input.suprefix.margin};
        `}

    color: ${input.suprefix.color};

    display: flex;
    height: 100%;
    align-items: center;

    ${ParagraphMd} {
      line-height: ${input.suprefix.paragraph['line-height']};
      color: ${input.suprefix.paragraph.color};
      font-size: ${input.suprefix.paragraph['font-size']};
    }
  `);
const FeedbackIcon = styled.div(({ hasSuffix, theme: { olist: { components: { input }, }, }, isLoading, feedback, }) => css `
    ${hasSuffix &&
    css `
      padding-right: 0;
    `}
    ${isLoading
    ? css `
          svg {
            animation: ${rotate} 2s linear infinite;
          }
        `
    : feedback
        ? css `
          svg {
            color: ${input.suprefix['feedback-icon'][feedback].color};
            animation: ${scaleIcon} 200ms ease-in;
          }
        `
        : ''}
  `);
const WrapperLabel = styled.div(() => css `
    display: flex;
    align-items: center;
  `);
const OptionalLabel = styled.span(({ theme: { olist: { components: { input }, }, }, }) => css `
    color: ${input.optionallabel.color};
    font-size: ${input.optionallabel['font-size']};
    font-family: ${input['font-family']};
    margin-left: ${input.optionallabel.margin};
    margin-right: ${input.optionallabel.margin};
    font-style: ${input.optionallabel['font-style']};
  `);

export { FeedbackIcon, OptionalLabel, StyledInput, Suprefix, Wrapper, WrapperInput, WrapperLabel };
